import { createBrowserSdk, setSdk } from "@chotca/api-client";
import { exchangeRefreshToken } from "@chotca/auth";
import { API_BASE_URL } from "@/env";
import { getAccessToken, setAccessToken } from "./access-token";

const APP_HEADERS = { "X-Chotca-App": "admin" } as const;

let bootstrapped = false;
let refreshing: Promise<boolean> | null = null;

const PUBLIC_AUTH_PATHS = ["/login", "/forgot-password", "/reset-password"];

function isOnAuthPage(): boolean {
  if (typeof window === "undefined") return false;
  const p = window.location.pathname;
  return PUBLIC_AUTH_PATHS.some(
    (path) => p === path || p.startsWith(`${path}/`),
  );
}

function redirectToLogin(): void {
  if (typeof window === "undefined") return;
  if (isOnAuthPage()) return;
  const back = window.location.pathname + window.location.search;
  const url = `/login?redirect=${encodeURIComponent(back)}`;
  window.location.assign(url);
}

async function performRefresh(): Promise<boolean> {
  if (refreshing) return refreshing;
  refreshing = (async () => {
    const result = await exchangeRefreshToken("__cookie__", API_BASE_URL, {
      credentials: "include",
      headers: APP_HEADERS,
    });
    if (result.ok) {
      setAccessToken(result.tokens.accessToken);
      return true;
    }
    if (result.reason === "invalid_session") {
      setAccessToken(null);
      redirectToLogin();
    }
    return false;
  })();
  try {
    return await refreshing;
  } finally {
    refreshing = null;
  }
}

export function installSdk(): void {
  if (bootstrapped) return;
  bootstrapped = true;
  setSdk(
    createBrowserSdk({
      baseUrl: API_BASE_URL,
      getAccessToken: async () => getAccessToken(),
      onUnauthorized: async () => performRefresh(),
      extraHeaders: APP_HEADERS,
    }),
  );
}

export async function bootstrapAuth(): Promise<void> {
  await performRefresh();
}
